<template>
  <div>
    <FormInputText
      @input="valueUpdated"
      :value="value"
      :placeholder="placeholder"
      :note="note"
      :field="field"
      :readonly="readonly"
    />
    <div class="form-invalid-feedback" v-if="hasEmailError()">
      <i class="fas fa-exclamation-triangle"></i> Please enter a valid email address
    </div>
  </div>
</template>


<script>
export default {
  name: 'FormInputEmail',
  props: {
    value: [String, Number],
    placeholder: String,
    field: String,
    note: String,
    readonly: Boolean,
    showEmailWarnings: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    hasEmailError() {
      if(!this.showEmailWarnings)
        return false
      if(this.isEmptyString(this.value))
        return false

      return !this.isValidEmail(this.value)
    },
    valueUpdated(value) {
      if(value) {
        value = (value + '').trim()
        value = this.sanitizeEmail(value)
      }

      this.$emit('input', value)
    }
  }
}
</script>